import React, { Fragment } from "react";
import Icon from "../Icon";
import PropTypes from "prop-types";
import { fundStatusColor, fundStatusLabel } from "../../helpers/fund";

const Disease = ({ disease, displayStatus }) => {
  if (!disease) return null;

  // Prefer WP title, then Fund_Name, then Disease
  const displayName =
    (disease.wpTitle && String(disease.wpTitle).trim()) ||
    (disease.Fund_Name && String(disease.Fund_Name).trim()) ||
    (disease.Disease && String(disease.Disease).trim()) ||
    "";

  if (!displayName) return null;

  function renderTitle() {
    if (disease.permalink) {
      return (
        <a className="Glossary-term" href={disease.permalink}>
          {displayName}
        </a>
      );
    } else {
      return <p className="Glossary-term -static">{displayName}</p>;
    }
  }

  // Choose link text based on status
  var linkText = "Learn more";
  var status = (disease.Fund_Status || "").toLowerCase();
  var nextStepURL = disease.permalink;

  if (status === "open") {
    linkText = "Check eligibility and apply";
  } else if (status === "closed" || status === "closed, wait list available" || status === "open to wait list only" || status === "wait list processing") {
    linkText = "Get notified when this fund opens";
    nextStepURL = 'https://totalassist.org/notify';
  } else if (status === "open to wait list only") {
    linkText = "Check eligibility";
  }

  // Format Assistance_Amount as whole-dollar currency
  function formatCurrency(value) {
    if (value == null) return "—";
    var num = parseFloat(value);
    if (isNaN(num)) return "—";
    return num.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  var formattedAmount = formatCurrency(disease.Assistance_Amount);

  return (
    <Fragment>
      <td>{renderTitle()}</td>
      <td>{formattedAmount}</td>
      {displayStatus && (
        <td>
          <span
            className={`Glossary-term-label f-label-small Glossary-term-label--${fundStatusColor(
              disease
            )}`}
          >
            {fundStatusLabel(disease)}
          </span>
        </td>
      )}
      <td>
        {nextStepURL && (
          <a className="Glossary-term" href={nextStepURL} {...(nextStepURL.includes('totalassist') && { target: "_blank", rel: "noopener" })}>
            <span className="fund-status-text">{linkText}</span>
            <svg
              className="next-step-svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_789_2803)">
                <path
                  d="M24 12.5C24 6.02148 18.7285 0.75 12.25 0.749999C5.77148 0.749999 0.5 6.02148 0.499999 12.5C0.499999 18.9785 5.77148 24.25 12.25 24.25C18.7285 24.25 24 18.9785 24 12.5ZM2 12.5C2 6.84766 6.59766 2.25 12.25 2.25C17.9023 2.25 22.5 6.84766 22.5 12.5C22.5 18.1523 17.9023 22.75 12.25 22.75C6.59766 22.75 2 18.1523 2 12.5Z"
                  fill="#8E1395"
                />
                <path
                  d="M17.7803 13.0312C18.0732 12.7383 18.0732 12.2617 17.7803 11.9687L13.7803 7.96875C13.4873 7.67773 13.0127 7.67773 12.7197 7.96875C12.4268 8.26172 12.4268 8.73828 12.7197 9.03125L15.4392 11.75L7.25 11.75C6.83594 11.75 6.5 12.0859 6.5 12.5C6.5 12.9141 6.83594 13.25 7.25 13.25L15.4392 13.25L12.7197 15.9687C12.5732 16.1152 12.5 16.3086 12.5 16.5C12.5 16.6914 12.5732 16.8848 12.7197 17.0312C13.0127 17.3223 13.4873 17.3223 13.7803 17.0312L17.7803 13.0312Z"
                  fill="#8E1395"
                />
              </g>
              <defs>
                <clipPath id="clip0_789_2803">
                  <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(24.25 0.5) rotate(90)"
                  />
                </clipPath>
              </defs>
            </svg>
          </a>
        )}
      </td>
    </Fragment>
  );
};

Disease.propTypes = {
  disease: PropTypes.object,
  displayStatus: PropTypes.bool,
};

export default Disease;
